// extracted by mini-css-extract-plugin
module.exports = {"resultsHeader":"resultsHeader_3KmI2","pipe":"pipe_1DPgb"};